import { gql } from "@apollo/client";

export const IGNORE_REPORTED_FEED = gql`
  mutation ignoreReportedFed($id: Int!) {
    ignoreReportedFeed(id: $id) {
      message
    }
  }
`;
